import React from "react";
import { useHistory  } from "react-router-dom";
import _ from "lodash";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    background: "#3FA052",
    display: "flex",
    height: 59,
    position: "fixed",
    zIndex: 10000,
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  text: {
    fontFamily: "Lato",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#00152E",
  },
  mainText: {
    fontWeight: 900,
    marginLeft: "32px",
  },
  actionButtons: {
    marginRight: "28px",
    alignItems: "center",
    display: "flex",
  },
  resume: {
    marginRight: 20,
    color: "#03090E",
    fontWeight: 700,
    fontSize: 24,
  },
});

const ResumeTripPanel = ({ activeTripId }: { activeTripId: string }) => {
  const classes = useStyles();
  const history = useHistory();

  const goToActiveTripModal = () => {
    history.push(`/transfertrip/${activeTripId}`);
  };

  return (
    <div className={classes.root} onClick={goToActiveTripModal}>
      <div className={classes.text}>
        <span className={classes.mainText}>Trip in Progress</span>
      </div>
      <div className={classes.actionButtons}>
        <span className={classes.resume}>Resume Trip</span>
        <ArrowForwardIosIcon style={{ fontSize: 20, color: "#03090E" }} />
      </div>
    </div>
  );
};

export default ResumeTripPanel;
